<template>
    <div>
        <div class="dx-field">
            <div class="dx-field-label">
                {{ meta.title }}
                <div class="dx-field-item-required-mark" v-if="isRequiered">&nbsp;*</div>
            </div>
            <div :class="fieldValueClass">
                <dx-date-box v-model:value="value" @valueChanged="valueChanged" />
                <div v-if="error" class="ai-dx-invalid"></div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { inject, computed } from 'vue';
import DxDateBox from 'devextreme-vue/date-box';

const props = defineProps({
    meta: {
        type: Object,
        default: () => ({}),
    },
    callbacks: {
        type: Object,
        default: () => ({ userDataChanged: null }),
    },
});

const userData = inject('userData');
const validationResult = inject('validationResult');

const isRequiered = computed(() => {
    return props.meta.validationRules?.required;
});

const error = computed(() => {
    return validationResult.value.find(s => s.fieldNameText === props.meta.fieldNameText);
});

const valueChanged = e => {
    userDataChange(e.value);
};

const value = computed(() => {
    if (userData?.value[props.meta.fieldNameText] === undefined) {
        return null;
    }
    return userData?.value[props.meta.fieldNameText];
});

const userDataChange = value => {
    userData.value[props.meta.fieldNameText] = value;
    props.callbacks.userDataChanged();
};

const fieldValueClass = computed(() => {
    return {
        'dx-field-value': true,
    };
});
</script>
